// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 97 ? "npm.regenerator-runtime" : chunkId) + "." + {"97":"cfe0d2d4","414":"1ee4edb1"}[chunkId] + ".chunk.js";
};